import { useDataValue } from 'Simple/Data.js'

/** @type {import('Simple/types.js').useDataConfiguration} */
export default function useDataConfiguration(props) {
  let person = useDataValue({
    context: 'appointment_overlay',
    viewPath: props.viewPath,
    path: 'patient_new.person',
  })

  return {
    variables: {
      first_name: person.first_name.trim(),
      last_name: person.last_name.trim(),
      birth_date: person.birth_date,
      birth_date_s: person.birth_date,
    },
  }
}
